
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const statusParams = {
  state: {
    groups: []
  },
  mutations: {
    addStatusParams (state, group) {
      state.groups.push(group)
    },
    removeStatusParams (state, GroupID) {         // Išmeta iš sąrašo grupę parametrų
      delete state.groups[GroupID]
    },
    clearStatusParams (state) {
      state.groups = []
    },
    setStatusParamValue (state, Message) {
      // Vue.$set(state.groups[0], Message.paramId, '111') // Message.value)
      // state.groups[Message.groupId][Message.paramId] = Message.value   // Expecting: {groupId: 100, paramId: 'param1', value: 'reiksme'}
      var grp = state.groups.find(x => x.id === Message.groupId)
      var param 
      if(grp)
        param = grp.params.find(x => x.id === Message.paramId.id)
      if(param)
        grp.params.find(x => x.id === Message.paramId.id).value = Message.value
      //Vue.set(state.groups[Message.groupId], Message.paramId, Message.value)
    }
  },
  getters: {
    getListOfStatusGroups (state) {
      return state.groups
    },
    getStatusParamValue: (state, getters) => (groupId, paramId) => {
      if (state.groups[groupId]) return state.groups[groupId][paramId]
      else return ''
    },
    getStatusGrpsValue: (state) => {
      return state.groups
    }
  }
}
